(() => {
  const drawer = document.querySelector('[data-ks-drawer]');
  const opener = document.querySelector('[data-ks-menu-open]');
  if (!drawer || !opener) return;

  const closeButtons = drawer.querySelectorAll('[data-ks-menu-close]');
  const firstLink = drawer.querySelector('a');
  const open = () => {
    drawer.setAttribute('aria-hidden', 'false');
    opener.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('ks-menu-open');
    window.setTimeout(() => firstLink?.focus(), 40);
  };
  const close = () => {
    drawer.setAttribute('aria-hidden', 'true');
    opener.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('ks-menu-open');
    opener.focus();
  };

  opener.addEventListener('click', open);
  closeButtons.forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
  });
})();
